import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL || '/api';

function getSafeAdminRedirect(redirect) {
  if (!redirect || !redirect.startsWith('/admin/') || redirect.startsWith('//')) {
    return '/admin/dashboard';
  }
  return redirect;
}

function AdminLogin() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const response = await fetch(`${API_URL}/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      });
      const data = await response.json();
      if (response.ok) {
        localStorage.setItem('adminToken', data.token);
        const redirect = searchParams.get('redirect') || '/admin/dashboard';
        const safeRedirect = getSafeAdminRedirect(redirect);
        navigate(safeRedirect, { replace: true });
      } else {
        setError(data.error || 'Ungültige Anmeldedaten');
      }
    } catch (err) {
      console.error(err);
      setError('Fehler bei der Anmeldung');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main>
      <h2>Admin Login</h2>
      {error && <p>{error}</p>}
      <form onSubmit={handleSubmit}>
        <label>
          E-Mail
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </label>
        <label>
          Passwort
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </label>
        <button type="submit" disabled={loading}>
          {loading ? 'Anmelden…' : 'Anmelden'}
        </button>
      </form>
    </main>
  );
}

export default AdminLogin;
